module.exports = __webpack_public_path__ + "64e7c9bd5275c5d2b8fd46148dc1b27a.png";